<template>
    <nav class="navbar navbar-expand navbar-dark static-top">
        <div class="navbar-brand-wrapper">
            <a class="navbar-brand" href="/">
                <img src="@/assets/images/ITA_Airways_Logo.svg" alt="" />
            </a>
        </div>
        <button class="btn btn-lg text-white border-0" id="sidebarToggle" @click="toggleSidebar" href="javascript:;">
            <font-awesome-icon icon="bars" />
        </button>
        <!-- Navbar -->
        <ul class="navbar-nav ml-auto" v-click-outside="hideMenus" v-if="currentUser">
            <li class="nav-item dropdown no-arrow mx-1" v-if="currentUser.tasks">
                <a @click="toggleMenu('alert')" class="nav-link dropdown-toggle" :class="{ show: alert }" href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <font-awesome-icon :icon="['far', 'bell']" />
                    <span class="badge badge-danger">{{ currentUser.tasks.length }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right p-3" :class="{ show: alert }" aria-labelledby="alertsDropdown">
                    <p class="mb-0">
                        Hai {{ currentUser.tasks.length }} tasks aperti.
                    </p>
                    <ul class="list-group">
                        <li v-for="(task, index) in currentUser.tasks" :key="index" class="list-group-item p-0 border-0 mt-3">
                            <div class="preview-item-content">
                                <router-link :to="{ name: 'mission-detail', params: { id: task.task_parent }}">
                                    <h6 class="preview-subject font-weight-medium mb-0">{{ task.task_name }}</h6>
                                    <p class="font-weight-light small-text m-0">
                                        {{ task.created_at }}
                                    </p>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="nav-item dropdown no-arrow mx-1" v-if="currentUser.messages && currentUser.messages.length">
                <a @click="toggleMenu('message')" class="nav-link dropdown-toggle" :class="{ show: message }" href="#" id="messagesDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <font-awesome-icon :icon="['far', 'envelope']" />
                    <span class="badge badge-danger">{{ currentUser.messages.length }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right p-3" :class="{ show: message }" aria-labelledby="messagesDropdown">
                    <router-link
                        class="dropdown-item"
                        v-for="message in currentUser.messages"
                        :key="message.id"
                        :to="{ name: 'message-detail', params: { id: message.id }}"
                    >
                        {{ message.title }}
                    </router-link>
                </div>
            </li>
            <li class="nav-item dropdown no-arrow">
                <a @click="toggleMenu('user')" class="nav-link dropdown-toggle" :class="{ show: user }" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <font-awesome-icon icon="user" />
                </a>
                <div class="dropdown-menu dropdown-menu-right" :class="{ show: user }" aria-labelledby="userDropdown">
                    <a class="dropdown-item" @click="userProfile">Il mio profilo</a>
                    <!-- <a class="dropdown-item" href="#">Activity Log</a> -->
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="signout" href="javascript:;" data-toggle="modal" data-target="#logoutModal">Logout</a>
                </div>
            </li>
        </ul>
    </nav>
</template>
<script>
import {
    mapGetters
} from 'vuex'
import {
    SET_TOGGLE
} from '@/store/mutations.type'
import {
    LOGOUT
} from '@/store/actions.type'
import ClickOutside from 'vue-click-outside'
export default {
    name: 'top-bar',
    data () {
        return {
            alert: false,
            message: false,
            user: false
        }
    },
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'currentUser',
            'toggledSidebar'
        ])
    },
    methods: {
        toggleMenu (type) {
            this.hideMenus()
            this[type] = true
        },
        hideMenus () {
            this.alert = false
            this.message = false
            this.user = false
        },
        signout () {
            this.$store.dispatch(LOGOUT)
            this.$router.push({
                name: 'login'
            })
        },
        toggleSidebar () {
            this.$store.commit(SET_TOGGLE, !this.toggledSidebar)
        },
        userProfile () {
            this.$router.push({
                name: 'user-detail',
                params: {
                    id: this.currentUser.id
                }
            })
        }
    },
    directives: {
        ClickOutside
    }
}
</script>
